import React, { createContext, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from './AuthContext';
import { setNavigateRef } from './../utils/NavigationService';

const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const { accessToken } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    setNavigateRef(navigate);
  }, [navigate]);

  const navigateTo = (path, requiredPermissions = []) => {
    if (accessToken) {
      const storedPermissions = JSON.parse(localStorage.getItem('permissions') || '[]').map(Number);
      if (requiredPermissions.length === 0 || requiredPermissions.some((p) => storedPermissions.includes(Number(p)))) {
        navigate(path);
      } else {
        navigate('/permission-denied');
      }
    } else {
      navigate('/login');
    }
  };

  return (
    <NavigationContext.Provider value={{ navigateTo }}>
      {children}
    </NavigationContext.Provider>
  );
};

export default NavigationContext;
